import React from 'react';
import ReactDOM from 'react-dom';
import globalMaterialUITheme from '@alo/yoga-ui';
import { Grid, ThemeProvider } from '@material-ui/core';
import styles from './styles.module.scss';

const {
  mobileAppAdPopup: { iosUrl },
} = window.getSiteSettings();

const device = {
  ios: {
    imageURL: 'https://cdn.shopify.com/s/files/1/2185/2813/files/Group_4.jpg?v=1629996396',
    storeURL: iosUrl,
    altText: 'Alo App - iOS App Store',
  },
};

const DownloadApp = () => {
  return (
    <ThemeProvider theme={globalMaterialUITheme}>
      <Grid container direction="row" className={styles.downloadApp}>
        <Grid container sm={6} md={6} alignItems="center" justify="center">
          <Grid container direction="column" alignItems="center" justify="center">
            <Grid item className="main-header">
              <h2>Get the alo app</h2>
            </Grid>
            <Grid item>
              <p className="large-p center sub-header">
                Make your move today for early drop access, exclusive deals & more!
              </p>
            </Grid>

            <Grid container direction="row" alignItems="center" justify="center" className={styles.mobile}>
              <AppStoreButtonUI />
            </Grid>
            <Grid item className={styles.desktop}>
              <img
                className="qrcode"
                src="https://cdn.shopify.com/s/files/1/2185/2813/files/qr-aloyoga-app2.png?v=1587080145"
                alt="qr-code"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item sm={6} md={6} lg={6} xl={4} alignItems="center" justify="center">
          <img
            className={styles.img}
            src="https://cdn.shopify.com/s/files/1/2185/2813/files/Group_8.png?v=1629909925"
            alt="mobile"
          />
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

const AppStoreButtonUI = () => {
  const { ios } = device;
  return (
    <Grid item>
      <a href={ios.storeURL}>
        <img src={ios.imageURL} alt={ios.altText} />
      </a>
    </Grid>
  );
};

ReactDOM.render(<DownloadApp />, document.getElementById('DownloadApp'));

export default DownloadApp;
